export default function Quality() {
    return (
        <div className="relative py-16 px-6 bg-black/50 backdrop-blur-sm">

            {/* DARK OVERLAY (optional for better readability) */}
            <div className="absolute inset-0 bg-black/40"></div>

            <div className="relative max-w-7xl mx-auto text-white">

                {/* HERO */}
                <div className="text-center mb-14">
                    <h1 className="text-4xl md:text-5xl font-extrabold">
                        QUALITY ASSURANCE
                    </h1>
                    <p className="mt-5 text-lg max-w-3xl mx-auto text-gray-200">
                        श्री बालाजी मसाला में हम गुणवत्ता, शुद्धता और भरोसे का वादा करते हैं।
                        हमारे सभी उत्पाद ISO और FSSAI मानकों के अनुसार तैयार किए जाते हैं।
                    </p>
                </div>

                {/* CERTIFICATIONS */}
                <div className="grid md:grid-cols-3 gap-8 mb-14">

                    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center border border-white/20 hover:bg-white/20 transition">
                        <div className="text-4xl mb-4">🏭</div>
                        <h3 className="text-xl font-bold">आधुनिक उत्पादन इकाई</h3>
                        <p className="mt-3 text-gray-200">
                            अत्याधुनिक मशीनों और स्वच्छ वातावरण में तैयार किए गए मसाले,
                            जो गुणवत्ता और शुद्धता की पूरी गारंटी देते हैं।
                        </p>
                    </div>

                    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center border border-white/20 hover:bg-white/20 transition">
                        <div className="text-4xl mb-4">🛡️</div>
                        <h3 className="text-xl font-bold">FSSAI Approved</h3>
                        <p className="mt-3 text-gray-200">
                            सभी उत्पाद FSSAI द्वारा प्रमाणित और सुरक्षित।
                        </p>
                    </div>

                    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center border border-white/20 hover:bg-white/20 transition">
                        <div className="text-4xl mb-4">🌿</div>
                        <h3 className="text-xl font-bold">100% Pure Ingredients</h3>
                        <p className="mt-3 text-gray-200">
                            उच्च गुणवत्ता वाले प्राकृतिक मसालों का उपयोग।
                        </p>
                    </div>

                </div>

                {/* PROCESS SECTION */}
                <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 mb-14">

                    <h2 className="text-3xl font-bold text-center mb-10">
                        OUR QUALITY PROCESS
                    </h2>

                    <div className="grid md:grid-cols-4 gap-8 text-center">

                        <div>
                            <div className="text-3xl mb-3">🌾</div>
                            <h4 className="font-semibold text-lg">Raw Material Selection</h4>
                            <p className="mt-2 text-gray-200 text-sm">
                                बेहतरीन कच्चे मसालों का चयन।
                            </p>
                        </div>

                        <div>
                            <div className="text-3xl mb-3">🔬</div>
                            <h4 className="font-semibold text-lg">Quality Testing</h4>
                            <p className="mt-2 text-gray-200 text-sm">
                                हर बैच की गुणवत्ता जांच।
                            </p>
                        </div>

                        <div>
                            <div className="text-3xl mb-3">⚙️</div>
                            <h4 className="font-semibold text-lg">Hygienic Processing</h4>
                            <p className="mt-2 text-gray-200 text-sm">
                                स्वच्छ और आधुनिक मशीनों से प्रोसेसिंग।
                            </p>
                        </div>

                        <div>
                            <div className="text-3xl mb-3">📦</div>
                            <h4 className="font-semibold text-lg">Safe Packaging</h4>
                            <p className="mt-2 text-gray-200 text-sm">
                                एयरटाइट पैकेजिंग से ताजगी बरकरार।
                            </p>
                        </div>

                    </div>
                </div>

                {/* MANUFACTURING SECTION – UNIFIED CARD STYLE */}
                <div className="mb-16">

                    <h2 className="text-3xl font-bold text-center mb-12 text-white">
                        OUR MANUFACTURING FACILITY
                    </h2>

                    <div className="max-w-6xl mx-auto bg-black/60 backdrop-blur-md rounded-3xl p-8 md:p-14 border border-white/20 shadow-2xl space-y-16">

                        {/* ITEM 1 */}
                        <div className="grid md:grid-cols-2 gap-10 items-center">
                            <div>
                                <h3 className="text-2xl font-semibold mb-4 text-[#ffb3b8]">
                                    Hygienic Manual Packing
                                </h3>
                                <p className="text-gray-300 leading-relaxed">
                                    हमारे प्रशिक्षित कर्मचारी स्वच्छ और सुरक्षित वातावरण में
                                    सावधानीपूर्वक मसालों की पैकिंग करते हैं।
                                    हर पैकेट को गुणवत्ता जांच के बाद ही सील किया जाता है,
                                    ताकि ग्राहकों तक शुद्ध और ताजा मसाले पहुंचें।
                                </p>
                            </div>

                            <div className="rounded-2xl overflow-hidden border border-white/20">
                                <img
                                    src="/images/quality/packing.jpg"
                                    alt="Manual Packing"
                                    className="w-full h-72 object-cover"
                                />
                            </div>
                        </div>

                        {/* ITEM 2 */}
                        <div className="grid md:grid-cols-2 gap-10 items-center">
                            <div>
                                <h3 className="text-2xl font-semibold mb-4 text-[#ffb3b8]">
                                    Automatic Sealing Machine
                                </h3>
                                <p className="text-gray-300 leading-relaxed">
                                    आधुनिक पैकेजिंग मशीनों की सहायता से सटीक माप,
                                    तेज उत्पादन और सुरक्षित सीलिंग सुनिश्चित की जाती है।
                                    इससे हर पैकेट में समान गुणवत्ता और स्वच्छता बनी रहती है।
                                </p>
                            </div>

                            <div className="rounded-2xl overflow-hidden border border-white/20">
                                <img
                                    src="/images/quality/automatic-machine.jpg"
                                    alt="Automatic Packaging Machine"
                                    className="w-full h-72 object-cover"
                                />
                            </div>
                        </div>

                        {/* ITEM 3 */}
                        <div className="grid md:grid-cols-2 gap-10 items-center">
                            <div>
                                <h3 className="text-2xl font-semibold mb-4 text-[#ffb3b8]">
                                    Advanced Grinding Process
                                </h3>
                                <p className="text-gray-300 leading-relaxed">
                                    उन्नत ग्राइंडिंग मशीनों से मसालों को बारीक और शुद्ध रूप में
                                    तैयार किया जाता है। यह प्रक्रिया मसालों की प्राकृतिक खुशबू
                                    और स्वाद को बरकरार रखती है।
                                </p>
                            </div>

                            <div className="rounded-2xl overflow-hidden border border-white/20">
                                <img
                                    src="/images/quality/grinding.jpg"
                                    alt="Grinding Process"
                                    className="w-full h-72 object-cover"
                                />
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
}